import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PaginationState } from '@shared/models/pagination-state';

@Component({
  selector: 'app-pagination-options',
  templateUrl: './pagination-options.component.html',
  styleUrls: ['./pagination-options.component.scss'],
  standalone: false,
})
export class PaginationOptionsComponent implements OnInit, OnChanges {
  @Input() paginationState: PaginationState;
  @Output() paginationStateChange = new EventEmitter<PaginationState>();
  maxPages = 6;
  perPage: string;
  pageButtonArray: number[] = [];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    if (!!this.paginationState) {
      this.perPage = this.paginationState.per_page.toString();
      let pageButtonsCount =
        this.paginationState.total_pages > this.maxPages ? this.maxPages - 1 : this.paginationState.total_pages - 1;
      if (this.paginationState.page + pageButtonsCount <= this.paginationState.total_pages) {
        this.pageButtonArray = Array.from({ length: pageButtonsCount }, (v, i) =>
          this.paginationState.page >= this.maxPages ? this.paginationState.page + i : i + 2,
        );
      } else {
        this.pageButtonArray = Array.from(
          { length: pageButtonsCount },
          (v, i) => this.paginationState.total_pages + i - pageButtonsCount + 1,
        );
      }
    }
  }

  changePerPage(event: any) {
    this.paginationStateChange.emit({
      ...this.paginationState,
      page: 1,
      per_page: parseInt(event.detail.value),
    });
  }

  nextPage() {
    if (this.paginationState.page < this.paginationState.total_pages) {
      this.paginationStateChange.emit({
        ...this.paginationState,
        page: this.paginationState.page + 1,
      });
    }
  }

  previousPage() {
    if (this.paginationState.page > 1) {
      this.paginationStateChange.emit({
        ...this.paginationState,
        page: this.paginationState.page - 1,
      });
    }
  }

  selectPage(page: number) {
    if (page >= 1 && page <= this.paginationState.total_pages) {
      this.paginationStateChange.emit({ ...this.paginationState, page: page });
    }
  }
}
